module.exports = __webpack_public_path__ + "img/bd(1).84747ab1.png";